import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const PauseIcon = ({ className }) => (
  /* eslint max-len: ["error", { "ignoreStrings": true }] */
  <SvgIcon viewBox='0 0 17.93 17.93' className={className}>
    <path
      id='Path_13259'
      data-name='Path 13259'
      d='M10.538,2.619A9.026,9.026,0,0,0,19.5-6.346a9.039,9.039,0,0,0-8.974-8.965A9.029,9.029,0,0,0,1.573-6.346,9.031,9.031,0,0,0,10.538,2.619ZM8.244-3.173c-.4,0-.589-.211-.589-.536V-8.974c0-.316.185-.536.589-.536h.8a.508.508,0,0,1,.58.536v5.265c0,.325-.185.536-.58.536Zm3.788,0c-.4,0-.589-.211-.589-.536V-8.974a.515.515,0,0,1,.589-.536h.8a.508.508,0,0,1,.58.536v5.265c0,.325-.185.536-.58.536Z'
      transform='translate(-1.573 15.311)'
      fill='#ff9d00'
      opacity='0.8'
    />
  </SvgIcon>
);

export default PauseIcon;
